<template>
<div class="addmarket">
  <div class="addmarket--header">
    <div class="addmarket--header--title">
      <div class="title--cancle" @click="handleToCancelAddMarket($route.params.routerName,$route.params.routeTag)">取消</div>
      <div class="title--text" v-if="addmReadOnly">{{$route.params.routerName?'修改':'新增'}}客户/渠道</div>
      <div class="title--text" v-else>查看客户/渠道</div>
      <div class="title--complete" @click="addmReadOnly && handleToPostAddMarket()">
        <span v-if="addmReadOnly">提交</span>
      </div>
    </div>
    <div class="addmarket--header--text">客户信息</div>
  </div>
  <div class="header-line"></div>
  <div class="addmarket--info">
    <div class="addmarket--info--name">
      <div class="item--name">类型</div>
      <div class="item--address">{{matterTypeValue}}</div>
    </div>
    <div class="addmarket--info--name addmarket--info--list" :class="{active:checkFieldList.includes('cusName')}">
      <div class="item--name">名称</div>
      <input type="text" class="item--ipt" :disabled="!addmReadOnly"  @input="handleToGetCompanyList" placeholder="请输入客户名称" v-model="cusName">
      <div class="item--img--icon iconfont" v-if="companyListFlag" @click="handleToClearCusName">&#xe606;</div>
      <div class="item--img--icon iconfont" v-else>
        <van-uploader :after-read="handleToReadCertificate" v-if="addmReadOnly" />
      </div>
      <div class="company-list" v-if="companyListFlag">
        <template v-if="searchDataList.length>0">
          <div
            class="company-list-item"
            v-for="item in searchDataList"
            :key="item.CreditCode+Math.random()"
            @click="handleToSelectCompany(item)"
          >
            {{item.Name}}
          </div>
        </template>
      </div>
    </div>
    <div class="addmarket--info--name" :class="{active:checkFieldList.includes('certCode')}">
      <div class="item--name">证件号</div>
      <input type="text" class="item--ipt" :disabled="!addmReadOnly" placeholder="请输入证件号" v-model="certCode">
    </div>
    <div
      class="addmarket--info--name"
      @click="handleToMarketToMap" :class="{active:checkFieldList.includes('address') ||checkFieldList.includes('lng') }"
      v-if="false"
    >
      <div class="item--name">地址</div>
      <div class="item--address">{{this.$store.state.locationData.address?this.$store.state.locationData.address:'点击获取定位'}}</div>
      <div class="item--icon iconfont">&#xe62b;</div>
    </div>
    <div class="addmarket--info--name"  :class="{active:checkFieldList.includes('staffNumber')}">
      <div class="item--name">拟合作金额(万元)</div>
      <input type="text" :disabled="!addmReadOnly" class="item--ipt item--ipt-money" placeholder="请输入拟合作金额" v-model="staffNumber">
    </div>
    <div class="addmarket--info--name" :class="{active:checkFieldList.includes('cusSource')}" @click="addmReadOnly && handleToCustomSourceIndustry('STD_MM_CUS_SOURCE')">
      <div class="item--name">客户来源</div>
      <div class="item--address">{{cus_source_text?cus_source_text:'点击选择来源'}}</div>
      <div class="item--icon iconfont" v-if="addmReadOnly">&#xe62c;</div>
    </div>
    <div class="addmarket--info--name" :class="{active:checkFieldList.includes('cusSource')}" @click="addmReadOnly && handleToGetChannelList()" v-if="cusSource === '3'">
      <div class="item--name">渠道名称</div>
      <div class="item--address">{{channelName?channelName:'点击获取渠道名称'}}</div>
      <div class="item--icon iconfont" v-if="addmReadOnly">&#xe62c;</div>
    </div>
    <div class="addmarket--info--name" :class="{active:checkFieldList.includes('sourceExplain')}">
      <div class="item--name">来源说明</div>
      <textarea class="item--area" v-if="addmReadOnly" placeholder="请输入客户来源说明" v-model="sourceExplain"  rows="3"></textarea>
      <div class="item--address" v-else>{{sourceExplain?sourceExplain:'无'}}</div>
    </div>
    <div class="addmarket--info--name" :class="{active:checkFieldList.includes('cusIndustry')}" @click="addmReadOnly && handleToCustomSourceIndustry('STD_MM_CUS_INDUSTRY')">
      <div class="item--name">所属行业</div>
      <div class="item--address">{{cus_industry_text?cus_industry_text:'点击选择行业'}}</div>
      <div class="item--icon iconfont" v-if="addmReadOnly">&#xe62c;</div>
    </div>
    <div class="addmarket--info--name addmarket--info--desc" :class="{active:checkFieldList.includes('industryExplain')}" >
      <div class="item--name">产业说明</div>
      <textarea class="item--area" v-if="addmReadOnly" placeholder="请输入产业说明" v-model="industryExplain"  rows="3"></textarea>
      <div class="item--address" v-else>{{industryExplain?industryExplain:'无'}}</div>
    </div>
    <div class="addmarket--info--name">
      <div class="item--name">备注</div>
      <textarea class="item--area" :disabled="!addmReadOnly" :placeholder="addmReadOnly?'请输入备注':''" rows="3" v-model="remark"></textarea>
    </div>
    <div class="addmarket--info--text" >
      <div>联系人</div>
      <div class="text--item iconfont" @click="handleToAddContract" v-if="addmReadOnly" >&#xe602;</div>
    </div>
    <div class="addmarket--info--contract" v-if="mmContactsList.length>0">
        <div
          class="contract--item"
          v-for="(item,index) in mmContactsList"
          :key="(item.contactPhone + index)"
        >
          <div class="item-icon iconfont" @click="handleToDelContract(item.contactPhone)" v-if="addmReadOnly">&#xe638;</div>
          <div class="item--name">{{item.contactName}}</div>
          <div class="item--phone">{{item.contactPhone}}</div>
          <div class="item--job">{{item.post}}</div>
        </div>
    </div>
    <div class="addmarket--info--name" v-if="addmReadOnly">
      <div class="item--name">姓名</div>
      <input type="text" class="item--ipt" placeholder="请输入联系人姓名" v-model="contactName">
    </div>
    <div class="addmarket--info--name" v-if="addmReadOnly">
      <div class="item--name">联系电话</div>
      <input type="text" class="item--ipt" placeholder="请输入联系电话" v-model="contactPhone">
    </div>
    <div class="addmarket--info--name addmarket--info--job" v-if="addmReadOnly">
      <div class="item--name">职务</div>
      <input type="text" class="item--ipt" placeholder="请输入联系人职务" v-model="post">
    </div>
    <div class="addmarket--info--text">
      <div>项目组成员</div>
    </div>
    <div class="addmarket--info--name addmarket--info--person">
      <template v-if="mmFollowStaffList.length > 0">
        <div
          class="person--item"
          v-for="item in mmFollowStaffList"
          :key="item.actorno"
        >{{item.actorname}}</div>
      </template>
      <div class="person--item iconfont" @click="handleToSelectFollowPerson" v-if="addmReadOnly">&#xe602;</div>
    </div>
  </div>
  <van-popup
    v-model="sourceFlag"
    :close-on-click-overlay="false"
    position="bottom"
    :style="{ height: '30%' }"
  >
    <van-picker
      title="请选择内容"
      show-toolbar
      :visible-item-count="2"
      :columns="customSourceIndustryList"
      :default-index="0"
      @cancel="handleToCancleFloat"
      @confirm="hanldeToSelectSourceIndustry"
    />
  </van-popup>
  <van-popup
    v-model="loadingFlag"
    :close-on-click-overlay="true"
    position="center"
    :style="{ height: '60px',width:'60px',background:'none' }"
  >
    <van-loading  color="#1989fa" size="50" />
  </van-popup>
  <div class="addmarket--source" v-if="customFollowFlag">
    <div class="source--title">
      <div class="source--title--cancle" @click="handleToCancleFloat('customFollowFlag')">取消</div>
      <div class="source--title--text">选择项目成员</div>
      <div class="source--title--cancle" @click="handleToCancleFloat('customFollowFlagadd')">完成</div>
    </div>
    <div class="source--item--follow">
      <div
        class="source--item--follow__per"
        :class="{active:mmFollowStaffTag.includes(item.actorno)}"
        v-for="item in customFollowList"
        :key="item.actorno"
        @click="handleToAddFollowPerson(item)"
      >{{item.actorname}}</div>
    </div>
  </div>
  <div class="addfollowup--visit" v-if="channelFlag">
    <div class="visit--title">
      <div class="visit--title--text">选择渠道</div>
    </div>
    <div
      class="visit--item"
      v-for="chitem in channelList"
      :key="chitem.id"
      @click="handleToAddChannel(chitem)"
    >
      <div class="visit--item--icon iconfont">&#xe629;</div>
      <div class="visit--item--text">{{chitem.cusName}}</div>
    </div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { get, post, postfile, postjson } from '../api/api'
import { getFormEmptyField, getIndustryDict, getSourceDict } from '../tools/common'
export default {
  name: 'AddMarket',
  data () {
    return {
      sourceFlag: false,
      loadingFlag: false, // 解析证件内容的时候弹出加载
      customIndustryFlag: false,
      customFollowFlag: false,
      channelFlag: false, // 控制选择渠道推荐时控制页面显示
      companyListFlag: false, // 控制模糊搜索列表显示
      customSourceIndustryList: [],
      SourceIndustList: [],
      customFollowList: [],
      id: '', // 新增的是空,更新的是有值
      matterType: '0', // 营销类型
      matterTypeValue: '客户营销', // 营销类型的值，显示使用
      cusName: '', // 客户名称
      certCode: '', // 客户证件号
      certType: '', // 证件类型
      cusType: '', // 客户类型
      staffNumber: '', // 员工人数
      couldEdit: true, // 控制提交是否显示
      cusSource: '', // 客户来源(数字)
      cus_source_text: '', // 客户来源文本(显示)
      sourceExplain: '', // 来源说明
      channelId: '', // 渠道id
      channelName: '', // 渠道名称
      channelList: [], // 渠道列表
      cusIndustry: '', // 所属产业(数字)
      cus_industry_text: '', // 所属产业文本(显示)
      industryExplain: '', // 产业说明
      remark: '', // 渠道说明
      mmContactsList: [], // 联系人列表
      contactName: '', // 联系人姓名
      contactPhone: '', // 联系人电话
      post: '', // 联系人职务
      mmFollowStaffList: [], // 跟进人列表
      mmFollowStaffTag: [], // 标记是否选中跟进人
      checkFieldList: [], // 校验表单是否有空
      postFlag: true, // 控制提交一次之后未返回不能再提交
      startTime: '', // 打开该页面记录时间
      searchDataList: [], // 模糊搜索的列表
      addmReadOnly: true
    }
  },
  beforeMount () {
    this.startTime = new Date().getTime()
    this.certCode = ''
    this.cusName = ''
    this.certType = ''
    this.cusType = ''
    if (this.$route.params.oldMarketData || localStorage.getItem('postData')) {
      const paramsData = this.$route.params.oldMarketData ? this.$route.params.oldMarketData : JSON.parse(localStorage.getItem('postData'))
      this.handleToModifyMarketData(paramsData)
    } else {
      // 添加登陆人到项目成员
      this.handleToItemPerson()
    }
  },
  destroyed () {
    this.$store.commit('delLocationInfo', '')
  },
  methods: {
    // 拍照获取图片文件回调函数
    async handleToReadCertificate (file) {
      this.loadingFlag = true
      const formdata = new FormData()
      formdata.append('file', file.file, file.file.name)
      const result = await postfile('/api/CBMS-APP/docEReceive/uploadForOcr', formdata)
      if (result.success) {
        this.certCode = result.data.certCode
        this.cusName = result.data.cusName
        this.certType = result.data.certType
        this.cusType = result.data.cusType
        this.loadingFlag = false
        this.$toast.success(result.data.checkMessage)
      } else if (result.toString().indexOf('timeout')) {
        this.loadingFlag = false
        this.$toast.success('请求超时，重新录入')
      } else {
        this.loadingFlag = false
        this.$toast.success('证件照不规范')
      }
    },
    // 添加登陆人到项目成员
    handleToItemPerson () {
      this.mmFollowStaffList.push({
        actorname: this.$cookies.get('actorname'),
        actorno: this.$cookies.get('actorno')
      })
      this.mmFollowStaffTag.push(this.$cookies.get('actorno'))
    },
    // 打开客户来源和行业
    async handleToCustomSourceIndustry (val) {
      document.body.style.overflow = 'hidden'
      this.customSourceIndustryList = []
      this.SourceIndustList = []
      const result = await get('/api/CBMS-APP/sDic/getOpttypeList', {
        opttype: val
      })
      this.SourceIndustList = result.data
      result.data.forEach(item => {
        this.customSourceIndustryList.push(item.cnname)
      })
      this.$nextTick(() => {
        this.sourceFlag = true
      })
    },
    // 选择客户端来源和行业
    hanldeToSelectSourceIndustry (val) {
      const Objdata = this.SourceIndustList.filter(item => item.cnname === val)[0]
      if (Objdata.opttype === 'STD_MM_CUS_SOURCE') {
        this.cusSource = Objdata.enname
        this.cus_source_text = Objdata.cnname
      } else if (Objdata.opttype === 'STD_MM_CUS_INDUSTRY') {
        this.cusIndustry = Objdata.enname
        this.cus_industry_text = Objdata.cnname
      }
      this.sourceFlag = false
      document.body.style.overflow = 'auto'
    },
    /**
     * 获取渠道列表并打开选择列表
     * @returns {boolean}
     */
    async handleToGetChannelList () {
      const result = await get('/api/CBMS-APP/mmMarketMatter/popChannelList', {})
      if (result.success) {
        this.channelFlag = true
        this.channelList = result.data
      }
    },
    /**
     * 选择渠道
     * @returns {boolean}
     */
    handleToAddChannel (item) {
      this.channelId = item.id
      this.channelName = item.cusName
      this.channelFlag = false
    },
    // 添加联系人信息
    handleToAddContract () {
      const phoneReg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/
      if (!this.contactName || !this.contactPhone) {
        this.$toast.success('联系人信息未填写完整')
        return false
      } else if (!phoneReg.test(this.contactPhone)) {
        this.$toast.success('手机号包含非数字或不足11位')
        return false
      }
      this.mmContactsList.push({
        contactName: this.contactName,
        contactPhone: this.contactPhone,
        post: this.post
      })
      this.contactName = ''
      this.contactPhone = ''
      this.post = ''
    },
    // 删除联系人
    handleToDelContract (phone) {
      this.mmContactsList = this.mmContactsList.filter(item => item.contactPhone !== phone)
    },
    // 选择项目组成员
    async handleToSelectFollowPerson () {
      document.body.style.overflow = 'hidden'
      this.customFollowFlag = true
      const result = await get('/api/CBMS-APP/sUser/listByComBrId', {})
      if (result.success) {
        this.customFollowList = result.data.records
      }
    },
    // 添加项目组成员信息
    handleToAddFollowPerson (itemObj) {
      if (this.mmFollowStaffTag.includes(itemObj.actorno)) {
        this.mmFollowStaffTag.splice(this.mmFollowStaffTag.indexOf(itemObj.actorno), 1)
        this.mmFollowStaffList = this.mmFollowStaffList.filter(item => item.actorno !== itemObj.actorno)
      } else {
        this.mmFollowStaffList.push({
          actorname: itemObj.actorname,
          actorno: itemObj.actorno
        })
        this.mmFollowStaffTag.push(itemObj.actorno)
      }
    },
    // 修改营销事项数据
    async handleToModifyMarketData (marketData) {
      for (const key in marketData) {
        if (key === 'address' || key === 'lng' || key === 'lat') {
          const payLoad = { ...this.$store.state.locationData, [key]: marketData[key] }
          this.$store.commit('setLocationFunc', payLoad)
        } else if (key === 'cusIndustry' && marketData.cusIndustry) {
          this.cusIndustry = marketData.cusIndustry
          const IndustryText = await getIndustryDict(marketData[key])
          this.cus_industry_text = IndustryText
        } else if (key === 'cusSource' && marketData.cusSource) {
          this.cusSource = marketData.cusSource
          const SourceText = await getSourceDict(marketData[key])
          this.cus_source_text = SourceText
        } else if (key === 'couldEdit') {
          this.addmReadOnly = marketData[key] && !(this.$route.params.routeTag === 'public' || this.$route.params.routeTag === 'hismarket')
        } else {
          this[key] = marketData[key]
        }
      }
    },
    // 取消添加营销事项
    handleToCancelAddMarket (routerName, routeTag) {
      this.$store.commit('setLocationFunc', '')
      if (routerName) {
        this.$router.push({ name: routerName, params: { id: this.$route.params.id, routeTag } })
      } else {
        this.$router.push('/market')
      }
    },
    // 添加数据提交后端
    async handleToPostAddMarket () {
      if (this.contactName && this.contactPhone) {
        this.mmContactsList.push({
          contactName: this.contactName,
          contactPhone: this.contactPhone,
          post: this.post
        })
        this.contactName = ''
        this.contactPhone = ''
        this.post = ''
      } else if (this.mmContactsList.length === 0 && !this.contactName && !this.contactPhone) {
        this.$toast.success('联系人姓名和电话不能为空')
        return false
      }
      const numberReg = /^[1-9]+.?[0-9]*$/
      if (!numberReg.test(this.staffNumber)) {
        this.$toast.success('拟合作金额只能填写数字')
        return false
      }
      const postData = {
        id: this.id,
        matterType: this.matterType,
        cusName: this.cusName,
        certCode: this.certCode,
        cusType: this.cusType,
        certType: this.certType,
        address: this.$store.state.locationData.address ? this.$store.state.locationData.address : '',
        lng: this.$store.state.locationData.lng ? this.$store.state.locationData.lng : '',
        lat: this.$store.state.locationData.lat ? this.$store.state.locationData.lat : '',
        locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '',
        staffNumber: this.staffNumber,
        cusSource: this.cusSource,
        sourceExplain: this.sourceExplain,
        cusIndustry: this.cusIndustry,
        industryExplain: this.industryExplain,
        remark: this.remark,
        mmContactsList: this.mmContactsList,
        mmFollowStaffList: this.mmFollowStaffList
      }
      if (this.cusSource === '3') {
        postData.channelId = this.channelId
        postData.channelName = this.channelName
      }
      this.checkFieldList = getFormEmptyField(postData)
      if (this.checkFieldList.length === 0 && this.postFlag) {
        this.postFlag = false
        const result = await postjson('/api/CBMS-APP/mmMarketMatter/add', postData)
        if (result.success) {
          this.$toast.success({
            message: '数据添加完成',
            onClose: () => {
              this.postFlag = true
              this.customSourceFlag = false
              this.customIndustryFlag = false
              this.customSourceList = []
              this.customIndustryList = []
              this.cusName = ''
              this.certCode = ''
              this.staffNumber = ''
              this.cusSource = ''
              this.cus_source_text = ''
              this.sourceExplain = ''
              this.cusIndustry = ''
              this.cus_industry_text = ''
              this.channelId = ''
              this.channelName = ''
              this.industryExplain = ''
              this.remark = ''
              this.mmContactsList = []
              this.contactName = ''
              this.contactPhone = ''
              this.post = ''
              this.checkFieldList = []
              this.mmFollowStaffList = []
              this.mmFollowStaffTag = []
              this.$store.state.locationData = ''
              if (this.$route.params.routerName) {
                this.$router.push({
                  name: this.$route.params.routerName,
                  params: {
                    id: result.data.id,
                    certCode: result.data.certCode,
                    cusName: result.data.cusName
                  }
                })
              } else {
                this.$router.push('market')
              }
            }
          })
        } else {
          this.postFlag = true
          this.$toast.success(`${result.message}`)
        }
      } else {
        this.checkFieldList.forEach(item => {
          if (item === 'mmContactsList') {
            this.$toast.success('联系人未添加')
            return false
          } else if (item === 'mmFollowStaffList') {
            this.$toast.success('项目组成员未添加')
            return false
          } else {
            this.$toast.success('有内容未填写')
            return false
          }
        })
      }
    },
    // 跳转到地图
    handleToMarketToMap () {
      const lat = this.$store.state.locationData ? this.$store.state.locationData.lat : ''
      const lng = this.$store.state.locationData ? this.$store.state.locationData.lng : ''
      const modifyTag = this.$route.params.modifyTag
      const routerName = this.$route.params.routerName
      const id = this.$route.params.id
      this.$router.push({ name: 'marketmap', params: { localName: 'AddMarket', modifyTag, routerName, id, lat, lng } })
    },
    // 关闭浮层
    handleToCancleFloat (val) {
      if (val === 'customFollowFlag') {
        this.customFollowFlag = false
        this.mmFollowStaffList = []
        this.mmFollowStaffTag = []
        this.mmFollowStaffList.push({
          actorname: this.$cookies.get('actorname'),
          actorno: this.$cookies.get('actorno')
        })
        this.mmFollowStaffTag.push(this.$cookies.get('actorno'))
      } else if (val === 'customFollowFlagadd') {
        this.customFollowFlag = false
      } else {
        this.sourceFlag = false
      }
      document.body.style.overflow = 'auto'
    },
    // 名称支持模糊搜索
    async handleToGetCompanyList () {
      this.searchDataList = []
      document.body.style.overflow = 'hidden'
      if (this.cusName.length > 3) {
        const result = await get('/qccapi/dmp-service-web/service/qcc/getQccFuzzySearchList', {
          appId: '8389090cd69b40a5b43f084cbf4bb48b',
          searchKey: this.cusName,
          provinceCode: '',
          cityCode: '',
          pageIndex: '1',
          pageSize: '10'
        })
        if (result.data === null) {
          this.$toast.success('获取失败,请重新输入')
        } else {
          this.companyListFlag = true
          this.searchDataList = result.data.Result
        }
      } else {
        this.companyListFlag = false
        document.body.style.overflow = 'auto'
        this.searchDataList = []
      }
      if (this.cusName.length === 0) {
        this.cusName = ''
        this.certCode = ''
      }
    },
    // 选择公司
    handleToSelectCompany (item) {
      this.cusName = item.Name
      this.certCode = item.CreditCode
      this.companyListFlag = false
      document.body.style.overflow = 'auto'
      this.searchDataList = []
    },
    // 清空名称栏内容
    handleToClearCusName () {
      this.companyListFlag = false
      document.body.style.overflow = 'auto'
      // this.cusName = ''
      // this.certCode = ''
      this.searchDataList = []
    }
  },
  beforeRouteLeave (to, from, next) {
    const postData = {
      id: this.id,
      cusName: this.cusName,
      certCode: this.certCode,
      certType: this.certType,
      cusType: this.cusType,
      staffNumber: this.staffNumber,
      cusSource: this.cusSource,
      sourceExplain: this.sourceExplain,
      channelId: this.channelId,
      channelName: this.channelName,
      cusIndustry: this.cusIndustry,
      industryExplain: this.industryExplain,
      mmContactsList: this.mmContactsList,
      mmFollowStaffList: this.mmFollowStaffList,
      mmFollowStaffTag: this.mmFollowStaffTag
    }
    const tourl = to.path
    const fromurl = from.path
    const endTime = new Date().getTime()
    const time = endTime - this.startTime
    post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl, time })
    if (to.name === 'marketmap' && from.name === 'AddMarket') {
      localStorage.setItem('postData', JSON.stringify(postData))
      next()
    } else {
      localStorage.removeItem('postData')
      next()
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.addmarket
  position : relative
  width : 100vw
  min-height : 100vh
  padding-bottom : 64px
  overflow-x : hidden
  overflow-y : scroll
  .addmarket--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .addmarket--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--cancle
        width : 120px
        padding-left : 16px
        text-align : left
      .title--complete
        width : 120px
        padding-right : 16px
        text-align : right
      .title--text
        flex : 1
        text-align : center
    .addmarket--header--text
      box-sizing : border-box
      width : 100%
      display : flex
      background : #f7f7f7
      padding : 26.5px 16px
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
  .header-line
    height : 170px
    width : 100%
  .addmarket--info
    //margin-top : 16px
    padding-bottom :  64px
    .addmarket--info--name
      display : flex
      align-items : center
      margin : 0 16px
      padding : 16px 0
      border-bottom : 1px solid #8b8787
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      &.active
        border : 1px solid #b45858
      .item--name
        width : 150px
        line-height : 47px
      .item--icon
        width : 120px
        text-align : right
        padding-right : 16px
        line-height : 47px
        font-size: 48px
        color : #4282e1
      .item--img--icon
        text-align : center
        line-height : 48px
        font-size: 48px
        color : #4282e1
        &>>>.van-uploader__upload
          height : 47px
          background-color : #ffffff
          margin : 0
        &>>>.van-uploader__upload-icon
          color : #4282e1
          font-size: 48px
      .item--ipt
        flex : 1
        height : 32px
        padding : 16px 0 16px 16px
        border: none;
        border-radius: 8px
        outline : none
        margin : 0 16px
        &:focus
          border-color: #4282e1
          outline: none
        &:disabled
          background-color : #ffffff
          color: #000000
          opacity:1
      .item--area
        flex : 1
        padding : 0 0 16px 16px
        border: none;
        border-radius: 8px
        outline : none
        margin : 0 16px
        overflow: hidden;
        resize : none
        &::placeholder
          line-height : 130px
        &:focus
          border-color: #4282e1
          outline: none
        &:disabled
          background-color : #ffffff
          color: #000000
          opacity:1
      .item--address
        flex : 1
        margin-left : 16px
        padding : 16px 16px 16px 16px
        line-height : 47px
    .addmarket--info--desc
      margin-bottom : 0
    .addmarket--info--text
      display : flex
      justify-content : space-between
      align-items : center
      padding : 16px
      background : #f7f7f7
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      .text--item
        font-size: 48px
        padding : 8px 16px 8px 24px
        color : #4282e1
    .addmarket--info--job
      margin-bottom : 0
    .addmarket--info--follow
      margin-bottom : 0
      padding : 32px 16px
    .addmarket--info--person
      display : flex
      padding : 16px 0
      margin : 0 16px
      border-bottom : 1px solid #8b8787
      .person--item
        background-color : #4282e1
        margin-right : 32px
        width : 100px
        height : 100px
        line-height : 100px
        text-align : center
        border-radius : 50%
        color : #ffffff
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
      .person--plus
        font-size : 32px
    .addmarket--info--contract
      background-color : #707e8d
      font-family: MyriadPro-Regular
      font-size: 26px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .contract--item
        display : flex
        padding : 8px 0
        .item-icon
          width : 40px
          padding : 16px
          font-size : 24px
        .item--name
          flex : 1
          padding : 16px 0 16px 16px
        .item--phone
          padding : 16px 0
          flex : 1
        .item--job
          padding : 16px 0
          flex : 1
          padding-right : 16px
          text-align : right
    .addmarket--info--list
      position : relative
      .company-list
        position : absolute
        top : 100px
        left:0
        width : 100%
        height : 400px
        box-sizing : border-box
        padding : 16px
        background-color : rgba(0,0,0,0.3)
        box-shadow : 0px 0px 10px #c7bdbd
        overflow-y : scroll
        .company-list-item
          background-color : #ffffff
          padding : 32px 0
          text-align : center
          border-bottom : 1px solid #8b8787
          font-family: MyriadPro-Regular
          font-size: 32px
          font-weight: normal
          font-stretch: normal
          color: #333333
  .addmarket--source
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow-y : scroll
    .source--title
      display : flex
      background-color : #687591
      .source--title--cancle
        width : 150px
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .source--title--text
        flex : 1
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
    .source--item
      margin : 0 32px
      padding : 48px 0
      display : flex
      justify-content : center
      align-items : center
      border-left : 1px solid #aaa5a5
      .source--item--num
        width : 40px
        height : 40px
        margin-left : -20px
        line-height : 40px
        text-align : center
        border-radius : 50%
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
        background-color : #aaa5a5
        &.active
          color: #ffffff
          background-color : #4282e1
      .source--item--icon
        margin-left : 0
      .source--item--text
        flex : 1
        padding : 8px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        border-bottom : 1px solid #aaa5a5
        &.active
          color : #4282e1
      .source--title--product
        flex : 1
        padding : 8px 16px
        text-align : left
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        border-bottom : 1px solid #aaa5a5
        &.active
          color : #4282e1
        .product--desc
          margin-top : 16px
    .source--item--follow
      padding : 16px
      width : 100%
      box-sizing : border-box
      display : flex
      flex-wrap : wrap
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .source--item--follow__per
        width : calc(25% - 16px)
        padding : 16px 0
        text-align : center
        margin-top : 16px
        border : 1px solid #979393
        margin-right : 16px
        border-radius : 12px
        background-color : #F0F0F0
        &:nth-child(4n)
          margin-right : 0
        &.active
          color: #ffffff
          background-color :#7186d3
          border : 1px solid #979393
    .source--item--first
      border-left : none
      position : relative
      &:before
        position : absolute
        top: 70%
        left :0
        content : ""
        width : 1px
        height : 50%
        background-color : #aaa5a5
    .source--item--last
      border-left : none
      position : relative
      &:before
        position : absolute
        top: 0
        left :0
        content : ""
        width : 1px
        height : 30%
        background-color : #aaa5a5
    .source--product--first
      border-left : none
      position : relative
      &:before
        position : absolute
        top: 60%
        left :0
        content : ""
        width : 1px
        height : 50%
        background-color : #aaa5a5
  .addmarket--location
    position : absolute
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow : scroll
    .addmarket--location--title
      display : flex
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      background-color : #687591
      justify-content : center
      align-items : center
      .title--icon
        width : 100px
        padding : 16px
        text-align : right
        font-size : 48px
      .title--desc
        text-align : center
        flex : 1
    .addmarket--location--address
      display : flex
      margin : 16px 16px 0
      padding-bottom : 16px
      border-bottom : 1px solid #aaa5a5
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .address--desc
        width : 150px
      .address--text
        padding-left : 16px
        flex : 1
    .addmarket--location--nearby
      margin : 0 16px
      .nearby--item
        display : flex
        align-items : center
        margin-top : 24px
        padding : 16px 0
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .nearby--icon
          font-size : 38px
          width : 80px
          color : #aaa5a5
          &.active
            color : #4282e1
        .nearby--select
          font-size : 38px
          width : 80px
          color : #aaa5a5
          text-align : right
          &.active
            color : #4282e1
        .nearby--desc
          flex : 1
          &.active
            color : #4282e1
  .addfollowup--visit
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow-y : scroll
    .visit--title
      display : flex
      background-color : #687591
      .visit--title--text
        flex : 1
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .visit--title--cancle
        width : 150px
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
    .visit--item
      display : flex
      align-items : center
      margin : 16px 32px 0 32px
      border-radius : 12px
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      border : 1px solid #007aff
      color: #333333
      .visit--item--icon
        padding : 16px
        width : 48px
        color: #4282e1
      .visit--item--text
        flex : 1
        padding: 16px
        text-align : left
        .text-title
          padding-bottom : 8px
          font-size: 32px
          font-weight: normal
          font-stretch: normal
        .text-desc
          padding-top : 8px
          color : #007aff
    .visit--person
      padding : 16px
      width : 100%
      box-sizing : border-box
      display : flex
      flex-wrap : wrap
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .visit--person--content
        width : calc(25% - 16px)
        padding : 16px 0
        margin-top : 16px
        border : 1px solid #979393
        margin-right : 16px
        text-align : center
        border-radius : 12px
        background-color : #F0F0F0
        &:nth-child(4n)
          margin-right : 0
        &.active
          color: #ffffff
          background-color :#7186d3
          border : 1px solid #979393
</style>
